@if (showMainHeader) {
<div slot="header" fxLayout="column">
    <forge-toolbar class="tyl-card--header-border" [ngClass]="compactMode ? 'compact' : ''" style="display: block;">
        @if (HasTitle() && isPageHeader()) {
        <h1 slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'"
            class="tyl-card--header layout-row layout-align-start-center">
            {{viewTitle}}
        </h1>
        }
        @if (HasTitle() && !isPageHeader()) {
        <h2 slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'"
            class="tyl-card--header layout-row layout-align-start-center">
            {{viewTitle}}
        </h2>
        }
        @if (showHeaderBadge) {
        <div slot="start" class="tt-margin--left layout-row layout-align-start-center">
            @for (badge of visibleHeaderBadges; track badge) {
            <forge-badge [attr.theme]="badge.Theme">{{badge.Text}}
            </forge-badge>
            }
        </div>
        }
        @for (customCommand of customViewCommands; track customCommand) {
        <div slot="end">
            <forge-icon-button (click)="customCommand.action($event)" [dense]="compactMode">
                <forge-tooltip placement="bottom">{{customCommand.tooltip}}</forge-tooltip>
                <forge-icon [name]="customCommand.icon"></forge-icon>
            </forge-icon-button>
        </div>
        }
        @if (hasActions) {
        <div slot="end" class="layout-row layout-align-end-start">
            <metadata-action-menu [metadataActions]="viewActions" [model]="model" [formData]="datacontroller">
            </metadata-action-menu>
        </div>
        }
        @if (showMenu) {
        <forge-menu slot="end" [options]="menuOptions" (forge-menu-select)="menuItemSelected($event)" placement="bottom"
            [dense]="compactMode" style="margin-right: 4px;" (forge-menu-open)="menuOpened($event)">
            <forge-icon-button telemetry="Menu-Actions" aria-label="actions menu" [dense]="compactMode">
                <forge-icon name="more_vert"></forge-icon>
            </forge-icon-button>
        </forge-menu>
        }
    </forge-toolbar>
</div>
}

<!--The content below is only a placeholder and can be replaced.-->
@if (IsAttachmentsView) {
<metadata-attachments class="layout-fill" [title]="viewTitle" [view]="view" [datacontroller]="datacontroller"
    [model]="model">
</metadata-attachments>
}

@if ((loading || gridLoading) && IsGrid) {
<div class="flex layout-row layout-align-center-center">
    <busy-indicator [big]="true"></busy-indicator>
</div>
}

@if (showDialogBusyIndicator) {
<busy-indicator [page]="true" [dialog]="true"></busy-indicator>
}

@if (!IsAttachmentsView) {
<div style="height: 100%;">
    <div class="layout-fill layout-row layout-align-center-start">
        @if (IsCombinedView && !IsTabbedView && doneLoadingViews) {
        <div class="combined-view layout-fill">
            @for (row of rowArray; track trackByRow($index, row)) {
            <div class="layout-row layout-align-space-evenly-start">
                @for (view of getViewsForRow(row); track view; let i = $index)
                {
                <div class="flex-{{view.DrawWidth}} combined-view--view" style="height: 100%"
                    [ngClass]="viewHasTable(view)">
                    <div ngModelGroup="combinedView{{row}}_{{i}}_{{modelGroupSuffix}}" class="combined-view--model-group">
                        @if (wrapWithCard(view) && !isHidden(view)) {
                        <forge-card class="no-padding">
                            @if (!isHidden(view)) {
                            <metadata-view class="layout-column layout-fill" [viewTitle]="view.Title" [view]="view"
                                [onDelete]="onDeleteBind()" [datacontroller]="datacontroller" [model]="model"
                                [wrapInForm]="false" [isInView]="isInView" [addMode]="addMode" [viewOnly]="isViewOnly"
                                [saveableForm]="saveableForm" [isMenu]="isMenu"
                                [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                                [customViewCommands]="customViewCommands" [pageHeader]="false"
                                (modifierCallback)="subCallback($event)" [parentViewId]="parentViewId">
                            </metadata-view>
                            }
                        </forge-card>
                        }
                        @if (!wrapWithCard(view) && !isHidden(view)) {
                        <metadata-view [viewTitle]="view.Title" [view]="view" [onDelete]="onDeleteBind()"
                            [datacontroller]="datacontroller" [model]="model" [wrapInForm]="false"
                            [saveableForm]="saveableForm" class="layout-column" [isInView]="isInView"
                            [addMode]="addMode" [viewOnly]="isViewOnly" [isMenu]="isMenu"
                            [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                            [customViewCommands]="customViewCommands" (modifierCallback)="subCallback($event)"
                            [parentViewId]="parentViewId">
                        </metadata-view>
                        }
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
        @if (IsTabbedView) {
        <div class="layout-fill">
            @if (doneLoadingViews) {
            <div style="height: 100%;">
                <forge-toolbar [ngClass]="compactMode ? 'compact' : ''">
                    <forge-tab-bar slot="before-start" (forge-tab-bar-change)="activateTab($event)" secondary
                        [ngClass]="{'compact-tab-container': compactMode}" [activeTab]="tabIndex"
                        layout_mode="clustered" class="view-tab-bar">
                        @for (view of visibleTabViews; track view) {
                        <forge-tab attr.telemetry="Tab-{{view.Title}}" [ngClass]="{'compact-tab': compactMode}">
                            {{view.Title}}
                        </forge-tab>
                        }
                    </forge-tab-bar>
                    @if (showMenu) {
                    <forge-menu slot="end" [options]="menuOptions" placement="bottom" [dense]="compactMode"
                        (forge-menu-select)="menuItemSelected($event)" style="pointer-events: auto; margin-right: 4px;"
                        (forge-menu-open)="menuOpened($event)">
                        <forge-icon-button telemetry="Menu-Actions" [dense]="compactMode" aria-label="actions menu">
                            <forge-icon name="more_vert"></forge-icon>
                        </forge-icon-button>
                    </forge-menu>
                    }
                    @if (isCollapsible) {
                    <forge-icon-button slot="end" aria-label="Collapse header" (click)="toggleCollapsed()"
                        [dense]="compactMode">
                        <forge-icon [name]="collapseIcon"></forge-icon>
                    </forge-icon-button>
                    }
                </forge-toolbar>
                <div [hidden]="!isPanelOpen" class="panel-container" style="pointer-events: auto;">
                    <forge-view-switcher [attr.index]="tabIndex" animation-type="none"
                        style="height: calc(100% - 49px);">
                        @for (view of visibleTabViews; track view; let i = $index) {
                        <forge-view role="tabpanel" [ngClass]="fillSpaceClassForTabView(view!.Views)">
                            <div ngModelGroup="tabView{{i}}_{{modelGroupSuffix}}">
                                @if (!isHidden(view)) {
                                <metadata-view class="layout-fill tabbed-view" [viewTitle]="view.Title"
                                    [hideTitle]="true" [view]="view" [saveableForm]="saveableForm"
                                    [datacontroller]="datacontroller" [model]="model" [wrapInForm]="false"
                                    [onDelete]="onDeleteBind()" [isInView]="isInView" [addMode]="addMode"
                                    [viewOnly]="isViewOnly" [isMenu]="isMenu"
                                    [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                                    (modifierCallback)="subCallback($event)" [parentViewId]="parentViewId">
                                </metadata-view>
                                }
                            </div>
                        </forge-view>
                        }
                    </forge-view-switcher>
                </div>
            </div>
            }
        </div>
        }
        @if (IsCustom && IsSelfContained) {
        <div class="flex">
            @if (initialized) {
            <custom-view [customDataBinding]="customDataBinding" [component]="customView!.ControlName" class="flex">
            </custom-view>
            }
        </div>
        }
        @if ((!IsTable || IsMetadataPanelGrid) && !IsCard && !IsCombinedView && !IsSelfContained) {
        <forge-expansion-panel #expansionPanel open [attr.open]="isPanelOpen"
            (forge-expansion-panel-toggle)="savePanelSetting($event.detail)" class="flex"
            [style]="!isCollapsible ? {'pointer-events':'none'} : null" [ngClass]="{'collapsible-panel': isCollapsible}"
            role="region">
            @if (hasActions || HasTitle() || isCollapsible || hasCollapsibleMenu() || (hasCustomCommands && index == 0)
            || isBreadcrumbFilterView)
            {
            <forge-toolbar slot="header" style="outline: none; position: relative;"
                [ngClass]="compactMode ? 'compact' : ''">
                @if (HasTitle() && isPageHeader()) {
                <h1 slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'">
                    {{viewTitle}}
                </h1>
                }
                @if (HasTitle() && !isPageHeader()) {
                <h2 slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'">
                    {{viewTitle}}
                </h2>
                }
                @if (showHeaderBadge) {
                <div slot="start" class="tt-margin--left layout-row layout-align-start-center">
                    @for (badge of visibleHeaderBadges; track badge) {
                    <forge-badge [attr.theme]="badge.Theme">
                        {{badge.Text}}
                    </forge-badge>
                    }
                </div>
                }
                @for (customCommand of customViewCommands; track customCommand) {
                <div slot="end">
                    <forge-icon-button (click)="customCommand.action($event)" [dense]="compactMode">
                        <forge-tooltip placement="bottom">{{customCommand.tooltip}}</forge-tooltip>
                        <forge-icon [name]="customCommand.icon"></forge-icon>
                    </forge-icon-button>
                </div>
                }
                @if (hasActions) {
                <div slot="end" class="layout-row layout-align-end-start" style="pointer-events: auto;">
                    <!-- TODO Add compact functionality to metadata-action-menu -->
                    <metadata-action-menu [metadataActions]="viewActions" [model]="model" [formData]="datacontroller"
                        [expansionPanelAction]="true">
                    </metadata-action-menu>
                </div>
                }
                @if (isBreadcrumbFilterView) {
                <grid-query [gridId]="breadcrumbGridId" [model]="model" slot="end"></grid-query>
                }
                @if (showMenu) {
                <forge-menu slot="end" [options]="menuOptions" (forge-menu-open)="menuOpened($event)" placement="bottom"
                    [dense]="compactMode" forge-ignore (forge-menu-select)="menuItemSelected($event)"
                    style="pointer-events: auto;">
                    <forge-icon-button telemetry="Menu-Actions" [dense]="compactMode" aria-label="actions menu">
                        <forge-icon name="more_vert"></forge-icon>
                    </forge-icon-button>
                </forge-menu>
                }
                @if (isCollapsible) {
                <forge-icon-button slot="after-end" class="tt-margin--right" aria-label="toggle expansion"
                    [dense]="compactMode">
                    <forge-open-icon [open]="isPanelOpen"></forge-open-icon>
                </forge-icon-button>
                }
            </forge-toolbar>
            }
            @if (!IsGrid && !IsFooterView && (loading || gridLoading)) {
            <busy-indicator [card]="true">
            </busy-indicator>
            }
            <div class="panel-container metadata-padding" [ngClass]="{'dense-input': view.Dense}"
                style="pointer-events: auto;">
                <div class="flex layout-fill layout-row layout-align-center-start">
                    @if (IsMapView && !IsGrid) {
                    <div>
                        @if (initialized) {
                        <metadata-map-view [model]="model" [datacontroller]="datacontroller" [view]="mapView"
                            [getCenter]="getCenter" [getCoordinates]="getCoordinates" [recalculateMap]="recalculateMap"
                            [refreshToken]="refreshMapView()" class="flex">
                        </metadata-map-view>
                        }
                    </div>
                    }
                    @if (customView?.ControlName && !IsSelfContained && !IsGrid) {
                    <div>
                        @if (initialized) {
                        <custom-view [customDataBinding]="customDataBinding" [component]="customView.ControlName"
                            class="flex"></custom-view>
                        }
                    </div>
                    }
                    @if (!customView?.ControlName && !IsMapView && !IsChatView && !IsGrid && !loading) {
                    <metadata-panel class="flex" [metadata]="view.ViewMetaData" [model]="model" [isMenu]="isMenu"
                        [focusFirst]="isFocusFirst" [dense]="view.Dense" [datacontroller]="datacontroller"
                        [viewOnly]="isViewOnly" (modifierCallback)="subCallback($event)"
                        [ngClass]="{'compact-mode': compactMode}">
                    </metadata-panel>
                    }
                    @if (IsMetadataPanelGrid) {
                    <div class="layout-fill">
                        <metadata-panel-grid [hidden]="loading" [viewMetadata]="view"
                            [metadata]="gridView!.GridProperties" [viewOnly]="isViewOnly" [models]="gridData"
                            (customAdd)="create()" [hasCustomAdd]="true" [focusFirst]="isFocusFirst"
                            [dense]="view.Dense" [noWrap]="view.NoWrap" [canAdd]="getAddPermission()"
                            [compact]="IsCompact" (modifierCallback)="bindGridCallback($event)"
                            (copyAction)="copy($event)" [datacontroller]="datacontroller"
                            [ngClass]="{'compact-panel-grid': IsCompact, 'compact-mode': compactMode}"
                            (allowDeleteCheckFunction)="AllowDeleteCheckBind($event)" [allowDeleteBindingSet]="true">
                        </metadata-panel-grid>
                        @if (GridMinimum > 0) {
                        <input [hidden]="loading" type="number" name="minItems" hidden min="{{GridMinimum}}"
                            [ngModel]="numberOfRowsToShow" telemetry="Edit-minItems">
                        }
                    </div>
                    }
                </div>
            </div>
        </forge-expansion-panel>
        }
        @if (IsCard && !IsCardList && isPanelOpen) {
        <div class="flex">
            <card-metadata [cardMetadata]="cardView!.Card" [dense]="view.Dense" [viewOnly]="isViewOnly" [model]="model"
                [datacontroller]="datacontroller" fxFlex="100" class="tt-padding-bottom-sm"></card-metadata>
        </div>
        }
        @if (IsTable && !IsMetadataPanelGrid && !IsTree && !IsCardList && isPanelOpen) {
        <div class="view-table--container flex">
            @if (ShowMaxRowMessage) {
            <div class="forge-typography--heading2 tyl-card--header layout-row layout-align-start-center flex-auto">
                {{MaxRowMessage}}
            </div>
            }
            @if (!loading) {
            <metadata-table [hidden]="!!gridLoading" [serverPaging]="serverPaging" [entities]="gridData"
                [viewMetadata]="gridView!" [gridMetadata]="gridView!.GridProperties" [tableTitle]="viewTitle"
                [repositoryFunction]="commandFunctionBind()" [preRepositoryFunction]="preCommandFunctionBind()"
                [disableGridAdd]="disableGridAdd" [multipleEdit]="true" (modifierCallback)="gridCallbackBind($event)"
                [disableViewAction]="disableViewAction" [datacontroller]="datacontroller" [parentType]="parentType"
                [model]="model" [displayHeader]="!showMainHeader && !hideTitle" style="height: 100%; display: flex;"
                [parentView]="parentViewId" [isStepperGrid]="isStepperView">
            </metadata-table>
            }
            @if (GridMinimum > 0) {
            <input type="number" name="minItems" hidden [min]="GridMinimum" [(ngModel)]="numberOfRowsToShow"
                telemetry="Edit-GridMin">
            }
        </div>
        }
        @if (IsCardList && isPanelOpen && gridData.length > 0) {
        <div class="view-table--container flex">
            <card-list [view]="cardListGridView!" [entities]="gridData" [datacontroller]="datacontroller"
                [showHeader]="showMainHeader" [viewTitle]="viewTitle"></card-list>
        </div>
        }
        @if (IsTree && hasGridData && isPanelOpen) {
        <div class="view-table--container flex">
            <metadata-tree [viewMetadata]="treeView!" [entities]="gridData" [datacontroller]="datacontroller"
                class="flex">
            </metadata-tree>
        </div>
        }
        @if (hasErrors) {
        <div class="metadata-view-buttons">
            <forge-fab mini="true" theme="error" class="metadata-error--fab" telemetry="Submission-ShowErrors"
                (click)="showErrors()">
                <forge-icon name="error_outline"></forge-icon>
            </forge-fab>
        </div>
        }
    </div>
    @if (showIntervalProgress) {
    <div flex>
        <forge-linear-progress class="tt-margin--bottom"></forge-linear-progress>
    </div>
    }
</div>
}